/**
 * Featured collection slider (edit) – section logic.
 * Depends on theme.js exposing window.Shopify.theme.sections.registerSection, loadSection, and helpers.
 */
(function () {
  'use strict';

  var api = window.Shopify && window.Shopify.theme && window.Shopify.theme.sections;
  if (!api || !api.registerSection || !api.loadSection || !api.helpers) {
    return;
  }

  var register = api.registerSection;
  var load = api.loadSection;
  var h = api.helpers;

  var selectorsEditSlider = {
    navItems: '.featured-collection-slider-edit__tab-btn',
    sliderContainer: '.featured-collection-slider-edit__content.carousel',
    navButtons: '.carousel__navigation-buttons'
  };

  var classesEditSlider = {
    selected: 'selected',
    visible: 'visible',
    fadeout: 'fadeout',
    initReveal: 'init-reveal',
    reveal: 'reveal',
    galleryImageHidden: 'product-item__gallery-image--hidden',
    gallerySegmentHidden: 'product-item__gallery-bar-segment--hidden'
  };

  var sectionImpl = {
    onLoad: function () {
      this.events = [];
      this.carousels = [];
      var dataset = this.container.dataset;
      var productsPerView = dataset.productsPerView;
      var mobileProductsPerView = (dataset.mobileProductsPerView || '').trim();
      this.perView = parseInt(productsPerView, 10);
      this.mobilePerView = mobileProductsPerView === '1.5' ? 1.5 : parseInt(mobileProductsPerView, 10) || 1.5;
      this.productItem = h.ProductItem(this.container);
      this.carouselsElements = h.queryAll(selectorsEditSlider.sliderContainer, this.container);
      this.navItems = h.queryAll(selectorsEditSlider.navItems, this.container);
      this.navigationButtons = h.queryAll(selectorsEditSlider.navButtons, this.container);
      this._viewAllLink = h.queryOne('[data-view-all-link]', this.container);
      this._viewAllUrls = {};
      var urlsScript = h.queryOne('[data-view-all-urls]', this.container);
      if (urlsScript) {
        try { this._viewAllUrls = JSON.parse(urlsScript.textContent); } catch (e) {}
      }

      var self = this;
      this.navItems.forEach(function (button) {
        self.events.push(h.on(button, 'click', self._handleNavButton.bind(self)));
      });

      this.events.push(h.on(this.container, 'click', this._handleGalleryNav.bind(this)));
      this.events.push(h.on(this.container, 'click', this._handleSwatchClick.bind(this)));

      var enableGallery = this.container.dataset.enableProductCardGallery === 'true';
      if (enableGallery) {
        var self = this;
        var mouseOutHandler = function (e) { self._handleGalleryMouseOut(e); };
        var mouseOverHandler = function (e) { self._handleGalleryMouseOver(e); };
        document.addEventListener('mouseout', mouseOutHandler, true);
        document.addEventListener('mouseover', mouseOverHandler, true);
        this.events.push(function () {
          document.removeEventListener('mouseout', mouseOutHandler, true);
          document.removeEventListener('mouseover', mouseOverHandler, true);
        });
      }

      this._initCarousels();
      if (enableGallery) {
        this._applyVariantFilterToAllCards();
      }
      if (h.shouldAnimate(this.container)) {
        this.animateListSlider = h.animateListSlider(this.container);
      }
      // Ask LOP to init product items in this section (hover second image when gallery is off)
      var self = this;
      function dispatchLopInit() {
        try {
          document.dispatchEvent(new CustomEvent('lop:init-product-items', { detail: { container: self.container } }));
        } catch (e) {}
      }
      dispatchLopInit();
      // Second pass after Swiper and lazy images have settled so all slides get hover (e.g. first slides sometimes miss init)
      setTimeout(dispatchLopInit, 400);
      // Third pass to cover async Swiper load (theme.js loads Swiper via import().then(...))
      setTimeout(dispatchLopInit, 800);
    },

    _initCarousels: function () {
      var self = this;
      this.carouselsElements.forEach(function (container, index) {
        var navigationWrapper = h.queryOne('.featured-collection-slider-edit__navigation-buttons[data-navigation="' + index + '"]', self.container);
        var nextButton = navigationWrapper ? h.queryOne('[data-next]', navigationWrapper) : null;
        var prevButton = navigationWrapper ? h.queryOne('[data-prev]', navigationWrapper) : null;
        self.carousels.push(h.Carousel(container, {
          slidesPerView: self.mobilePerView,
          spaceBetween: 13,
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton
          },
          breakpoints: {
            720: {
              spaceBetween: 17,
              slidesPerView: self.perView === 5 ? self.perView - 1 : self.perView
            },
            1200: {
              spaceBetween: 25,
              slidesPerView: self.perView
            }
          }
        }));
      });
    },

    _variantIdInList: function (variantId, idsAttr) {
      if (!variantId) return false;
      var ids = (idsAttr || '').trim();
      if (!ids) return false;
      var normalized = ',' + ids + ',';
      return normalized.indexOf(',' + String(variantId) + ',') !== -1;
    },

    _applyVariantFilter: function (cardEl) {
      var variantId = cardEl.getAttribute('data-current-variant-id');
      if (variantId == null || variantId === '') return;
      var images = h.queryAll('.product-item__image--gallery', cardEl);
      var segments = h.queryAll('.product-item__gallery-bar-segment', cardEl);
      var self = this;
      images.forEach(function (img) {
        var belongs = self._variantIdInList(variantId, img.getAttribute('data-variant-ids'));
        if (belongs) {
          h.removeClass(img, classesEditSlider.galleryImageHidden);
        } else {
          h.addClass(img, classesEditSlider.galleryImageHidden);
        }
      });
      segments.forEach(function (seg) {
        var belongs = self._variantIdInList(variantId, seg.getAttribute('data-variant-ids'));
        if (belongs) {
          h.removeClass(seg, classesEditSlider.gallerySegmentHidden);
        } else {
          h.addClass(seg, classesEditSlider.gallerySegmentHidden);
        }
      });
      var visibleImages = [];
      var visibleSegments = [];
      for (var i = 0; i < images.length; i++) {
        if (!h.hasClass(images[i], classesEditSlider.galleryImageHidden)) {
          visibleImages.push(images[i]);
          visibleSegments.push(segments[i]);
        }
      }
      images.forEach(function (img) { h.removeClass(img, 'active'); });
      segments.forEach(function (seg) {
        h.removeClass(seg, 'active');
        if (seg.removeAttribute) seg.removeAttribute('aria-current');
      });
      if (visibleImages.length > 0) {
        h.addClass(visibleImages[0], 'active');
        h.addClass(visibleSegments[0], 'active');
        if (visibleSegments[0].setAttribute) visibleSegments[0].setAttribute('aria-current', 'true');
      }
    },

    _resetGalleryToFirst: function (cardEl) {
      var wrap = cardEl.querySelector('.product-item__gallery-images-wrap');
      if (!wrap) return;
      var images = cardEl.querySelectorAll('.product-item__image--gallery');
      var segments = cardEl.querySelectorAll('.product-item__gallery-bar-segment');
      var hiddenClass = classesEditSlider.galleryImageHidden;
      var visibleImages = [];
      var visibleSegments = [];
      for (var i = 0; i < images.length; i++) {
        if (!images[i].classList.contains(hiddenClass)) {
          visibleImages.push(images[i]);
          if (segments[i]) visibleSegments.push(segments[i]);
        }
      }
      if (visibleImages.length === 0) return;
      images.forEach(function (img) { img.classList.remove('active'); });
      segments.forEach(function (seg) {
        seg.classList.remove('active');
        if (seg.removeAttribute) seg.removeAttribute('aria-current');
      });
      visibleImages[0].classList.add('active');
      if (visibleSegments[0]) {
        visibleSegments[0].classList.add('active');
        if (visibleSegments[0].setAttribute) visibleSegments[0].setAttribute('aria-current', 'true');
      }
    },

    _handleGalleryMouseOut: function (e) {
      if (!e.target || !e.target.closest) return;
      if (!this.container.contains(e.target)) return;
      var gallery = e.target.closest('.product-item__media--gallery');
      if (!gallery || !this.container.contains(gallery)) return;
      if (e.relatedTarget && gallery.contains(e.relatedTarget)) return;
      var card = gallery.closest('.product-item');
      if (!card) return;
      var self = this;
      clearTimeout(this._galleryResetTimer);
      this._galleryResetCard = card;
      this._galleryResetTimer = setTimeout(function () {
        self._galleryResetTimer = null;
        self._galleryResetCard = null;
        self._resetGalleryToFirst(card);
      }, 50);
    },

    _handleGalleryMouseOver: function (e) {
      if (!e.target || !e.target.closest) return;
      if (!this.container.contains(e.target)) return;
      var gallery = e.target.closest('.product-item__media--gallery');
      if (!gallery || !this._galleryResetCard) return;
      if (gallery.closest('.product-item') !== this._galleryResetCard) return;
      clearTimeout(this._galleryResetTimer);
      this._galleryResetTimer = null;
      this._galleryResetCard = null;
    },

    _applyVariantFilterToAllCards: function () {
      var cards = h.queryAll('.product-item', this.container);
      var self = this;
      cards.forEach(function (card) {
        if (h.queryOne('.product-item__gallery-images-wrap', card)) {
          self._applyVariantFilter(card);
        }
      });
    },

    _handleSwatchClick: function (e) {
      var target = e.target && e.target.closest && e.target.closest('.product-swatches-options__item--swatch[data-variant-id]');
      if (!target) return;
      var variantId = target.getAttribute('data-variant-id');
      if (!variantId) return;
      var card = target.closest('.product-item');
      if (!card) return;
      var hasGallery = card.querySelector && card.querySelector('.product-item__gallery-images-wrap');
      card.setAttribute('data-current-variant-id', variantId);
      if (hasGallery) {
        this._applyVariantFilter(card);
      } else {
        this._updateCardFromSwatch(card, target);
      }
    },

    _getMainImage: function (card) {
      var main = card.querySelector('.product-item__image--one img');
      if (main) return main;
      var imgs = card.querySelectorAll('.product-item__image img');
      for (var i = 0; i < imgs.length; i++) {
        var w = imgs[i].closest && imgs[i].closest('.product-item__image');
        if (w && !w.classList.contains('product-item__image--two') && !w.classList.contains('LOP-second-image-wrapper') && !w.classList.contains('product-item__image--gallery')) {
          return imgs[i];
        }
      }
      return card.querySelector('.product-item__image-link img') || card.querySelector('.product-item__media img');
    },

    _normalizeImageUrl: function (url) {
      if (!url) return url;
      url = String(url).replace(/&amp;/g, '&');
      if (url.indexOf('//') === 0) {
        return (window.location.protocol || 'https:') + url;
      }
      return url;
    },

    _formatMoney: function (cents, card) {
      if (typeof cents === 'string') cents = parseInt(cents, 10);
      if (isNaN(cents)) return '';
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }
      var amount = (cents / 100).toFixed(2);
      var priceEl = card && card.querySelector && card.querySelector('.product-item__price .sale, .product-item__price span:not(.visually-hidden)');
      if (priceEl && priceEl.textContent) {
        var m = priceEl.textContent.trim().match(/^([^\d]+)/);
        if (m) return m[1] + amount;
      }
      return '$ ' + amount;
    },

    _updateCardFromSwatch: function (card, swatch) {
      var variantImageUrl = swatch.getAttribute('data-variant-image-url');
      var variantImageSrcset = swatch.getAttribute('data-variant-image-srcset') || '';
      var variantSecondImageUrl = swatch.getAttribute('data-variant-second-image-url');
      var variantSecondImageSrcset = swatch.getAttribute('data-variant-second-image-srcset') || '';
      var variantPrice = swatch.getAttribute('data-variant-price');
      var variantCompareAtPrice = swatch.getAttribute('data-variant-compare-at-price');
      var variantId = swatch.getAttribute('data-variant-id');

      var allSwatches = card.querySelectorAll('.product-swatches-options__item--swatch');
      for (var s = 0; s < allSwatches.length; s++) {
        allSwatches[s].classList.remove('LOP-swatch-active');
      }
      swatch.classList.add('LOP-swatch-active');

      if (variantId) {
        var imageLink = card.querySelector('.product-item__image-link');
        var titleLink = card.querySelector('.product-item__product-title a');
        [imageLink, titleLink].forEach(function (link) {
          if (link && link.getAttribute('href')) {
            var baseUrl = link.getAttribute('href').split('?')[0];
            link.setAttribute('href', baseUrl + '?variant=' + variantId);
          }
        });
      }

      if (variantPrice) {
        var priceContainer = card.querySelector('.product-item__price');
        if (priceContainer) {
          if (!card.dataset.originalPriceHtml) card.dataset.originalPriceHtml = priceContainer.innerHTML;
          var formattedPrice = this._formatMoney(variantPrice, card);
          var formattedCompare = variantCompareAtPrice ? this._formatMoney(variantCompareAtPrice, card) : null;
          var priceHtml = formattedCompare
            ? '<span class="visually-hidden">Precio regular</span><s class="t-subdued">' + formattedCompare + '</s> <span class="sale">' + formattedPrice + '</span>'
            : '<span>' + formattedPrice + '</span>';
          priceContainer.innerHTML = priceHtml;
        }
      }

      var mainImg = this._getMainImage(card);
      if (mainImg && variantImageUrl) {
        var url = this._normalizeImageUrl(variantImageUrl);
        var srcset = variantImageSrcset ? variantImageSrcset.split(', ').map(function (part) {
          var p = part.trim().split(/\s+/);
          var u = p[0];
          var rest = p.slice(1).join(' ');
          return (u ? this._normalizeImageUrl(u) : '') + (rest ? ' ' + rest : '');
        }.bind(this)).join(', ') : '';
        if (srcset) mainImg.srcset = srcset;
        else mainImg.removeAttribute('srcset');
        mainImg.decoding = 'sync';
        mainImg.loading = 'eager';
        mainImg.src = url;
      }

      var secondImg = card.querySelector('.product-item__image--two img');
      if (secondImg) {
        var secondUrl = variantSecondImageUrl ? this._normalizeImageUrl(variantSecondImageUrl) : (card.dataset.originalSecondImageSrc || '');
        if (secondUrl) {
          var secondSrcset = variantSecondImageSrcset ? variantSecondImageSrcset.split(', ').map(function (part) {
            var p = part.trim().split(/\s+/);
            var u = p[0];
            var rest = p.slice(1).join(' ');
            return (u ? this._normalizeImageUrl(u) : '') + (rest ? ' ' + rest : '');
          }.bind(this)).join(', ') : '';
          if (secondSrcset) secondImg.srcset = secondSrcset;
          else secondImg.removeAttribute('srcset');
          secondImg.decoding = 'sync';
          secondImg.loading = 'eager';
          secondImg.src = secondUrl;
        }
      }
    },

    _handleGalleryNav: function (e) {
      if (window.matchMedia && window.matchMedia('(max-width: 719px)').matches) return;
      var target = e.target && e.target.closest && e.target.closest('.product-item__gallery-prev, .product-item__gallery-next');
      if (!target) return;
      e.preventDefault();
      e.stopPropagation();
      var item = target.closest('.product-item');
      if (!item) return;
      var images = h.queryAll('.product-item__image--gallery', item);
      var segments = h.queryAll('.product-item__gallery-bar-segment', item);
      var visibleImages = [];
      var visibleSegments = [];
      for (var i = 0; i < images.length; i++) {
        if (!h.hasClass(images[i], classesEditSlider.galleryImageHidden)) {
          visibleImages.push(images[i]);
          visibleSegments.push(segments[i]);
        }
      }
      var total = visibleImages.length;
      if (total === 0) return;
      var current = -1;
      for (var j = 0; j < visibleImages.length; j++) {
        if (h.hasClass(visibleImages[j], 'active')) {
          current = j;
          break;
        }
      }
      if (current < 0) return;
      var nextIndex = h.hasClass(target, 'product-item__gallery-prev')
        ? (current - 1 + total) % total
        : (current + 1) % total;
      h.removeClass(visibleImages[current], 'active');
      h.removeClass(visibleSegments[current], 'active');
      if (visibleSegments[current].removeAttribute) visibleSegments[current].removeAttribute('aria-current');
      h.addClass(visibleImages[nextIndex], 'active');
      h.addClass(visibleSegments[nextIndex], 'active');
      if (visibleSegments[nextIndex].setAttribute) visibleSegments[nextIndex].setAttribute('aria-current', 'true');
    },

    _handleNavButton: function (e) {
      e.preventDefault();
      var navigationItem = e.currentTarget.dataset.navigationItem;
      if (!h.hasClass(e.currentTarget, classesEditSlider.selected)) {
        this._hideAll();
        this._show(parseInt(navigationItem, 10));
      }
    },

    _hideAll: function () {
      h.removeClass(this.navItems, classesEditSlider.selected);
      h.removeClass(this.navigationButtons, classesEditSlider.visible);
      h.removeClass(this.carouselsElements, classesEditSlider.initReveal);
      h.removeClass(this.carouselsElements, classesEditSlider.reveal);
      if (h.shouldAnimate(this.container)) {
        h.addClass(this.carouselsElements, classesEditSlider.fadeout);
        var self = this;
        setTimeout(function () {
          h.removeClass(self.carouselsElements, classesEditSlider.visible);
        }, 300);
      } else {
        h.removeClass(this.carouselsElements, classesEditSlider.visible);
      }
    },

    _updateViewAllLink: function (index) {
      if (!this._viewAllLink) return;
      var url = this._viewAllUrls[String(index)] || '';
      if (url) {
        this._viewAllLink.href = url;
        this._viewAllLink.style.display = '';
      } else {
        this._viewAllLink.style.display = 'none';
      }
    },

    _show: function (index) {
      var navigationWrapper = h.queryOne('.featured-collection-slider-edit__navigation-buttons[data-navigation="' + index + '"]', this.container);
      var collection = h.queryOne('[data-collection="' + index + '"]', this.container);
      if (navigationWrapper) h.addClass(navigationWrapper, classesEditSlider.visible);
      this._updateViewAllLink(index);
      if (this.navItems.length) {
        var navigationItem = h.queryOne('[data-navigation-item="' + index + '"]', this.container);
        if (navigationItem) h.addClass(navigationItem, classesEditSlider.selected);
      }
      if (!collection) return;
      if (h.shouldAnimate(this.container)) {
        h.addClass(collection, classesEditSlider.fadeout);
        h.addClass(collection, classesEditSlider.initReveal);
        var self = this;
        setTimeout(function () {
          h.addClass(collection, classesEditSlider.visible);
          h.removeClass(collection, classesEditSlider.fadeout);
          setTimeout(function () {
            h.addClass(collection, classesEditSlider.reveal);
          }, 50);
        }, 300);
      } else {
        h.addClass(collection, classesEditSlider.visible);
      }
    },

    onUnload: function () {
      clearTimeout(this._galleryResetTimer);
      this._galleryResetTimer = null;
      this._galleryResetCard = null;
      this.carousels.forEach(function (swiper) {
        swiper.destroy();
      });
      if (this.animateListSlider != null && typeof this.animateListSlider.destroy === 'function') {
        this.animateListSlider.destroy();
      }
      this.events.forEach(function (unsubscribe) {
        unsubscribe();
      });
    },

    onBlockSelect: function (payload) {
      var target = payload && payload.target;
      if (target && target.dataset && target.dataset.collection !== undefined) {
        this._hideAll();
        this._show(parseInt(target.dataset.collection, 10));
      }
    }
  };

  register('featured-collection-slider-edit', sectionImpl);
  load('featured-collection-slider-edit');
})();
